import script from "./DetalharVenda.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharVenda.vue?vue&type=script&setup=true&lang=js"

import "./DetalharVenda.vue?vue&type=style&index=0&id=1f44b66b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f44b66b"]])

export default __exports__